import { ReactElement } from "react";

export interface RouteData {
    routeProps: RouteProps;
    name: string;
}

export interface RouteProps {
    path: string;
    element: ReactElement<any, any>
}

export interface Action<T> {
    type: string,
    payload: T
}

export interface KeyValuePayload {
    key: string,
    value: any
}

export interface AuthModel {
    email: string,
    password: string,
}

export interface ValidatorResponse {
    isValidated: boolean,
    message: string
}

export type Customer = {
    id: number,
    userId: number,
    firstName: string,
    lastName: string,
    email: string,
    phoneNumber: string,
    platform: string,
    dateCreated: string,
    status: string,
    verificationStatus: string
}

export type Address = {
    id?: number,
    timeLogged: string,
    geoLocation: string,
    longitude: string,
    latitude: string,
    deviceType: string,
    lastLogin: string,
    ipAddress: string
}

export type User = {
    id: string,
    firstName: string,
    lastName: string,
    username: string,
    email: string,
    phoneNumber: string,
    permission: string,
    password?: string
}

export interface IUserRole {
    adminAccess: boolean|null,
    superAdminAccess: boolean,
    verificationAccess: boolean
}

export interface IUserCreationStages {
    userBasics: boolean,
    userRole: boolean,
    setupSummary: boolean
}

export interface ISubsidiaryCreationStages {
    details: boolean,
    documents: boolean
}

export interface ICompanyCreationStages {
    basicDetails: boolean,
    locationAndPassword: boolean
}

export interface ICustomerCreationStages {
    basicDetails: boolean,
    locationDetails: boolean
}

export type Subsidiary = {
    id: string,
    name: string,
    noOfCustomers: string,
    verifiedCustomers: string,
    unverifiedCustomers: string,
    email?: string,
    dateOfIncorporation?: string,
    phoneNumber?: string,
    website?: string,
    address?: string,
    city?: string,
    state?: string,
    country?: string,
    subsidiary: object,
    documentUrl?: string,
    registrationNumber?: string,
    verificationStatus?: string
}

export type Company = {
    id: string,
    name: string,
    active: boolean,
    profilePhoto: string,
    documentUrl?: string,
    hasSubsidiaries: boolean,
    verificationAlgorithm: object,
    parentOrganization: string,
    emailVerified: string,
    email?: string,
    dateOfIncorporation?: string,
    phoneNumber?: string,
    officialWebsite?: string,
    address?: string,
    city?: string,
    state?: string,
    country?: string,
    noOfSubsidiaries: string,
    subscriptionPlan: string,
    subscriptionTime: string,
    subscriptionStatus: string
}

export type CompanyCreation = {
    firstName: string,
    lastName: string,
    age: string,
    city: string,
    state: string,
    country: string,
    phoneNumber: string,
    email: string,
    name: string,
    password: string,
    address: string
}

export type CustomerCreation = {
    firstName: string,
    lastName: string,
    channel: string,
    city: string,
    state: string,
    country: string,
    mobileNo: string,
    email: string,
    platform: string,
    address: string
}

export enum UserType {
    INDIVIDUAL = 'INDIVIDUAL',
    COMPANY = 'COMPANY',
    ADMIN = 'ADMIN'
}

export type PopIcons = 'success'|'failure'|'password-change'|'subsidiary'|'address-verification'

export type DropdownOption = {
    label?: string,
    value: string
}

export type dashboardStats = {
    companies?: number,
    subsidiaries?: number,
    customers: {
        total: number,
        rate: number
    },
    verifiedAddresses: {
        total: number,
        rate: number
    },
    unverifiedAddresses: {
        total: number,
        rate: number
    },
}

export type verificationChart = {
    year: string,
    monthlyData: Array<verificationChartData>
}

export type verificationChartData = {
    month: string,
    verifiedCount: number,
    unverifiedCount: number
}

export type deviceStats = {

}

export type locationStats = {
    value: number,
    key: string
}

export type Devices = {
    macos: number,
    windows: number
    ios: number,
    android: number,
    api: number
}

export type Filter = {
    page: number,
    size: number,
    verificationStatus?: string|null,
    organizationId?: number,
    mostFrequent?: boolean
}

export type LocationData = {
    id: number,
    createdOnDate: string,
    isDeleted: boolean,
    address: string,
    latitude: number,
    longitude: number,
    ipAddress: string,
    channel: string,
    platform: string,
    state: string,
    city: string,
    country: string
}

export type PasswordChange = {
    newPassword: string,
    oldPassword: string
}